import rejestracjaZdarzeniaGTM from '../shared/rejestracja-zdarzenia-gtm';
import IZdarzenieGTMListing from '../types/IZdarzenieGTMListing';

const filtryBoczneClicked = (): void => {
  const event: IZdarzenieGTMListing = {
    clickedVersion: 'new',
    clickedElement: 'Other filters',
    clickedPageType: 'Listing',
    event: 'userClickTest',
  };

  rejestracjaZdarzeniaGTM<IZdarzenieGTMListing>(event);
};
export default filtryBoczneClicked;
